import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { ResultsService } from '../../../services/results.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material';
import { Observable, of } from 'rxjs';
import { startWith, map, switchMap, debounceTime } from 'rxjs/operators';
import { CommonService } from 'src/app/services/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { organizationDTO } from 'src/app/models/providersDTO';
import { PersistenceService, StorageType } from 'angular-persistence';
import { AgmMap, MouseEvent, MapsAPILoader } from '@agm/core';
import Swal from 'sweetalert2';
declare var $: any;
import { AbstractControl } from '@angular/forms';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})

export class DashboardComponent implements OnInit {
  public submitted = false;
  public pharmacysubmitted = false;
  public facilitysubmitted = false;
  public providersubmitted = false;
  public display='none';
  hideChoosePlan:boolean=true;
  contentPath = localStorage.getItem('ContentPath');
  /* AutoComplete for location region start */
   locationform: FormGroup;
   myPharmacy:FormGroup;
   myFacility:FormGroup;
   myProvider:FormGroup;
   srchlocationCtrl = new FormControl();
   
  public TempgridData: any[] = [];
  public tempLocations: any[] = [];
  latitude: number;
  longitude: number;
  getAddress: number;
 
  txtFindProvider:string;
  myLocation: string;
  interval: any;
  public autoLocationIntellegience: Observable<string[]>;
  @ViewChild('searchtextvalue', { read: MatAutocompleteTrigger, static: false }) autoComplete: MatAutocompleteTrigger;
  @ViewChild('search', { static: true }) search: ElementRef;

  /* AutoComplete for location region end  */
  /* AutoComplete for plan region start */
  
  srchplanCtrl = new FormControl();
  autoPlanIntellegience: any;
  @ViewChild('autoCompleteInput', { read: MatAutocompleteTrigger, static: false }) autoCompleteInput: MatAutocompleteTrigger; 
  plansString:string =localStorage.getItem('Plans');
  plans:any[]=this.plansString.split(',');
  public orgDetails: organizationDTO = new organizationDTO();
  constructor(private apiloader: MapsAPILoader,private commonService: CommonService, private router: Router, private formBuilder: FormBuilder, private resultsService: ResultsService, private spinner: NgxSpinnerService, private persistenceService: PersistenceService) {
    this.srchlocationCtrl = new FormControl('', Validators.required);
    this.srchplanCtrl = new FormControl();
    this.autoCompleteLocations();    
    this.autoCompletePlans();
  }

  ngOnDestroy() {
    let body = document.getElementsByTagName('body')[0];
    body.classList.remove("modal-open");

    let div = document.getElementsByClassName('modal-backdrop')[0];
    //div.classList.remove('modal-backdrop');
    if(div != undefined)
    body.removeChild(div);
     
  }
  ngOnInit() {
    this.spinner.show();
    this.myPharmacy = this.formBuilder.group({
      findPharmacy: ['', [Validators.required,ProvidernameValidation.PharmacyNameCheck]]      
    })
    this.myFacility = this.formBuilder.group({
      findfacility: ['', [Validators.required,ProvidernameValidation.FacilityNameCheck]]      
    })
    this.myProvider = this.formBuilder.group({
      findprovider: ['', [Validators.required,ProvidernameValidation.ProviderNameCheck]]      
    })
    this.locationform = this.formBuilder.group({
      _srchlocationCtrl: this.srchlocationCtrl,
      _srchplanCtrl:this.srchplanCtrl
    });
    $(document).ready(function() { 
    $('#srchplanCtrl').keypress(function (e) {
     // debugger;
      var regex = new RegExp("^[0-9a-zA-Z_\. ]+$");
      var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
      if (regex.test(str)) {
          return true;
      }
      e.preventDefault();
      return false;
    });
    });

    this.refreshData();
    this.interval = setInterval(() => { 
        this.refreshData(); 
    }, 60000);

    // this.resultsService.getNetworkZipCodes().subscribe((data: any[]) => {
    //   this.persistenceService.set('currentlocations', data, { type: StorageType.SESSION });
    //   this.TempgridData = data;
    // });     
    //this.getZipCodesList();
   // debugger;
    this.spinner.hide();
    this.persistenceService.set('currentplans', this.plans, { type: StorageType.SESSION });
  }

  async refreshData()
  {
    this.commonService.getOrganizationDetails().then((formdata) => {
      this.orgDetails = formdata[0];
    });
    this.resultsService.getNetworkZipCodes().subscribe((data: any[]) => {
      this.TempgridData = data;
    });
  }

 
  get _srchlocationCtrl(): any {
    return this.locationform.get('srchlocationCtrl');
  } 
  get _srchplanCtrl(): any {
    return this.locationform.get('srchplanCtrl');
  } 
  get myPharmacyControl() {
    return this.myPharmacy.controls;
  }
  get myFacilityControl() {
    return this.myFacility.controls;
  }
  get myProviderControl() {
    return this.myProvider.controls;
  }

  private autoCompleteLocations() {
   // debugger;
    this.autoLocationIntellegience = this.srchlocationCtrl.valueChanges.pipe(
      startWith(''),
      debounceTime(200),
      map(locaddress => {
        if(locaddress==undefined)
          {
            this.myLocation='Your Location';           
          }
       else if (locaddress.length >= 2) {
          return this._filter(locaddress)
        }
      })
    );
  }
  closemat() {
    this.autoComplete.closePanel();
  }
  openmat() {
    this.autoComplete.openPanel();
  }
 
  private _filter(locaddress: string): any[] {
    
    const filterValue = locaddress;
    return this.TempgridData.filter(locaddress => 
      locaddress.city.toLocaleLowerCase().indexOf(filterValue.toLocaleLowerCase()) == 0
      || locaddress.zipCode.toLocaleLowerCase().indexOf(filterValue.toLocaleLowerCase()) == 0
      || locaddress.stateCode.toLocaleLowerCase().indexOf(filterValue.toLocaleLowerCase()) == 0
      || locaddress.location.toLocaleLowerCase().indexOf(filterValue.toLocaleLowerCase()) == 0
      ).sort((a, b) => (a.city > b.city) ? 1 : ((b.city > a.city) ? -1 : 0));
  }

 
  FocusoutFunction() {
    this.submitted = false;
  }

  closemat1() {
    this.autoCompleteInput.closePanel();
  }
  openmat1() {
    
    this.autoCompleteInput.openPanel();
  }
  private autoCompletePlans() {
    this.autoPlanIntellegience = this.srchplanCtrl.valueChanges.pipe(
      startWith(''),
      debounceTime(200),
      map(plan => {
        if (plan.length >= 2) {
          return this._filterPlans(plan)
        }
      })
    );
  }
  _filterPlans(val: string) {
    const filterValue = val;
    return val ? this.plans.filter(s => s.toLowerCase().indexOf(val.toLowerCase()) === 0)
      : this.plans;
  }
  
  
  public searchproviders(action: string) {
    debugger;
    this.submitted = true;
    if (this.locationform.invalid) {
      return;
    }
    else {
    this.spinner.show();
    setTimeout(() => {
      
      this.myLocation=this.locationform.get('_srchlocationCtrl').value;
      var locsearch=this.myLocation;
      //var locsearch = this.locationform.get('_srchlocationCtrl').value
      if (this.myLocation != "Your Location") {
        var tempLocations = this.TempgridData.filter(locaddress => 
          locaddress.city.toLocaleLowerCase().indexOf(locsearch.toLocaleLowerCase()) == 0
          || locaddress.zipCode.toLocaleLowerCase().indexOf(locsearch.toLocaleLowerCase()) == 0
          || locaddress.stateCode.toLocaleLowerCase().indexOf(locsearch.toLocaleLowerCase()) == 0
          );
        if(tempLocations != null && tempLocations != undefined && tempLocations.length > 0)
          locsearch = tempLocations[0].location;
        
        if ((locsearch != undefined && locsearch != null && locsearch != "")) {
            this.resultsService.getLatlons(locsearch).then((formdata) => {
              
              if(formdata!=undefined && formdata.length>0)
              {
                this.latitude = formdata[0].latitude;
                this.longitude = formdata[0].longitude; 
              }                   
            });
        }
      }
      else {
        this.get();
      }
      
      var plnsearch = this.locationform.get('_srchplanCtrl').value;
      if(plnsearch == undefined || locsearch == null)
        plnsearch ="";
      if ((locsearch != undefined && locsearch != null && locsearch != "")) {
        setTimeout(() => {
        if((this.latitude != undefined && this.latitude != null && this.latitude != 0))
        {
            this.router.navigate(['/results'], { queryParams: {sp:"",locsearch:locsearch,latitude: this.latitude, longitude: this.longitude, _planSearch: plnsearch, _action: action } });
            this.submitted = false;
            this.spinner.hide();
        }
        else{
          this.spinner.hide();
          Swal.fire({            
            title: 'Something went wrong!',
            text:'Please try again with valid location!',
            icon: 'error'
          })
        } 
      },2000);       
      }
    }, 2000);
  }
}
btnSendRequest(){
    this.router.navigate(['sendrequest']);
}

  findProvider(action:string){
   // debugger;
    if(action == "pharmacy"){
      this.pharmacysubmitted = true;
      if (this.myPharmacy.invalid) {        
        this.spinner.hide();
        return;
      }
      else {  
        this.display='none'; //set none css after close dialog  
        //data-dismiss="modal"
        let element: HTMLElement = this.search.nativeElement;
        element.click();
        var text = this.myPharmacy.controls.findPharmacy.value;

        var loc = this.TempgridData.filter(locaddress => 
          locaddress.zipCode.toLocaleLowerCase().indexOf(text.toLocaleLowerCase()) == 0
          );

        
        if(loc != undefined && loc != null && loc.length > 0)
        {
          this.resultsService.getLatlons(loc[0].location).then((formdata) => {          
            if(formdata!=undefined && formdata.length>0)
            {
              this.latitude = formdata[0].latitude;
              this.longitude = formdata[0].longitude; 
            }                   
          });
  
          setTimeout(() => {
          this.myPharmacy.reset();
          if((this.latitude != undefined && this.latitude != null && this.latitude != 0))
          {
              this.router.navigate(['/results'], { queryParams: {sp:"",locsearch:loc[0].location,latitude: this.latitude, longitude: this.longitude, _planSearch: "", _action: action } });
              this.submitted = false;
              this.spinner.hide();
          }
          else{
            this.spinner.hide();
            Swal.fire({            
              title: 'Something went wrong!',
              text:'Please try again with valid location!',
              icon: 'error'
            })
          } 
        },2000);  
        }          
        else{
          this.myPharmacy.reset();
          this.router.navigate(['/providersearch'], { queryParams: { sp: this.commonService.getSearchValue(text), _action: action} });
        }
        }
    }
    else if(action == "facility"){
      this.facilitysubmitted = true;
      if (this.myFacility.invalid) {
        this.spinner.hide();
        return;
      }
      else { 

        this.display='none'; //set none css after close dialog  
        //data-dismiss="modal"
        let element: HTMLElement = this.search.nativeElement;
        element.click();
        var text = this.myFacility.controls.findfacility.value;

        var loc = this.TempgridData.filter(locaddress => 
          locaddress.zipCode.toLocaleLowerCase().indexOf(text.toLocaleLowerCase()) == 0
          );

        
        if(loc != undefined && loc != null && loc.length > 0)
        {
          this.resultsService.getLatlons(loc[0].location).then((formdata) => {          
            if(formdata!=undefined && formdata.length>0)
            {
              this.latitude = formdata[0].latitude;
              this.longitude = formdata[0].longitude; 
            }                   
          });
  
          setTimeout(() => {
          this.myFacility.reset();
          if((this.latitude != undefined && this.latitude != null && this.latitude != 0))
          {
              this.router.navigate(['/results'], { queryParams: {sp:"",locsearch:loc[0].location,latitude: this.latitude, longitude: this.longitude, _planSearch: "", _action: action } });
              this.submitted = false;
              this.spinner.hide();
          }
          else{
            this.spinner.hide();
            Swal.fire({            
              title: 'Something went wrong!',
              text:'Please try again with valid location!',
              icon: 'error'
            })
          } 
        },2000);  
        }          
        else{
          this.myFacility.reset();
          this.router.navigate(['/providersearch'], { queryParams: { sp: this.commonService.getSearchValue(text), _action: action} });
        }
        }
    }
    
    else if(action == "provider"){
     // debugger;
      this.providersubmitted = true;
      if (this.myProvider.invalid) {
        this.spinner.hide();
        return;
      }
      else {   
        
        this.display='none'; //set none css after close dialog  
        //data-dismiss="modal"
        let element: HTMLElement = this.search.nativeElement;
        element.click();
        var text = this.myProvider.controls.findprovider.value;
        //debugger;
        var loc = this.TempgridData.filter(locaddress => 
          locaddress.zipCode.toLocaleLowerCase().indexOf(text.toLocaleLowerCase()) == 0        
          );
        
        if(loc != undefined && loc != null && loc.length > 0)
        {
          this.resultsService.getLatlons(loc[0].location).then((formdata) => {          
            if(formdata!=undefined && formdata.length>0)
            {
              this.latitude = formdata[0].latitude;
              this.longitude = formdata[0].longitude; 
            }                   
          });
  
          setTimeout(() => {
          this.myProvider.reset();
          if((this.latitude != undefined && this.latitude != null && this.latitude != 0))
          {
              this.router.navigate(['/results'], { queryParams: {sp:"",locsearch:loc[0].location,latitude: this.latitude, longitude: this.longitude, _planSearch: "", _action: action } });
              this.submitted = false;
              this.spinner.hide();
          }
          else{
            this.spinner.hide();
            Swal.fire({            
              title: 'Something went wrong!',
              text:'Please try again with valid location!',
              icon: 'error'
            })
          } 
        },2000);  
        }          
        else
        {
          this.myProvider.reset();
          this.router.navigate(['/providersearch'], { queryParams: { sp: this.commonService.getSearchValue(text), _action: action} });
        }
        
        }
    }
    
  }

  openModalDialog(){
    this.display='block'; //Set block css
 }

 closeModalDialog(){
  this.display='none'; 
 }

 CloseModal(){
//this.myProvider.reset({findprovider: ''});
this.myProvider.reset();
this.providersubmitted=false;
this.myFacility.reset();
this.facilitysubmitted=false;
this.myPharmacy.reset();
this.pharmacysubmitted=false;
 }

 public get() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition((position: Position) => {
      if (position) {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.getAddress = (this.latitude, this.longitude)
        console.log(position)
        this.apiloader.load().then(() => {
          let geocoder = new google.maps.Geocoder;
          let latlng = {
            lat: this.latitude,
            lng: this.longitude
          };
          geocoder.geocode({
            'location': latlng
          }, function (results) {
            if (results[0]) {
              this.currentLocation = results[0].formatted_address;
              this.myLocation = this.currentLocation;
              //console.log(this.assgin);  
            } else {
              //console.log('Not found');  
            }
          });
        });
      }
    })
  }
  else {
    alert("Location is not supported by this browser");
  }
}
}

export class ProvidernameValidation {

   
  static ProviderNameCheck(AC: AbstractControl) :{[key:string]:boolean} | null{
      const formGroup = AC.parent;
      if (formGroup) {
          const providerNameControl = formGroup.get('findprovider'); // to get value in input tag
          if (providerNameControl) {
              const providername = providerNameControl.value;
              if(providername!='' && providername!=undefined)
              {
              let letterCount = providername.split(/\W/).join('').length;
              if(letterCount==0)
              {
                return {'invalidProviderName':true};
              }
              else
              {
                  return null;
              }
            }
             
          }
      }
      return null;
  }
  static FacilityNameCheck(AC: AbstractControl) :{[key:string]:boolean} | null{
    const formGroup = AC.parent;
    if (formGroup) {
        const providerNameControl = formGroup.get('findfacility'); // to get value in input tag
        if (providerNameControl) {
            const providername = providerNameControl.value;
            if(providername!='' && providername!=undefined)
            {
            let letterCount = providername.split(/\W/).join('').length;
            if(letterCount==0)
            {
              return {'invalidProviderName':true};
            }
            else
            {
                return null;
            }
          }
           
        }
    }
    return null;
}
static PharmacyNameCheck(AC: AbstractControl) :{[key:string]:boolean} | null{
  const formGroup = AC.parent;
  if (formGroup) {
      const providerNameControl = formGroup.get('findPharmacy'); // to get value in input tag
      if (providerNameControl) {
          const providername = providerNameControl.value;
          if(providername!='' && providername!=undefined)
          {
          let letterCount = providername.split(/\W/).join('').length;
          if(letterCount==0)
          {
            return {'invalidProviderName':true};
          }
          else
          {
              return null;
          }
        }
         
      }
  }
  return null;
}
}

